import { render, staticRenderFns } from "./MetaphorSelectList.vue?vue&type=template&id=a6b09968&scoped=true&"
import script from "./MetaphorSelectList.vue?vue&type=script&lang=js&"
export * from "./MetaphorSelectList.vue?vue&type=script&lang=js&"
import style0 from "./MetaphorSelectList.vue?vue&type=style&index=0&id=a6b09968&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6b09968",
  null
  
)

export default component.exports